export const MANAGE_SLACK_ACCESS_INFO_KEY = "manageSlackAccessInfo";
